const defineVuesticConfig = (config) => config;
export {
  defineVuesticConfig as d
};
//# sourceMappingURL=types.js.map
